export const SET_PRELOADER = 'SET_PRELOADER';

export default {
  SET_PRELOADER,
};
